'use client';

import { motion } from 'framer-motion';

const CONFETTI_COUNT = 100;
const COLORS = ['#FFC700', '#FF0000', '#2E3191', '#41BBC7'];

interface ConfettiPieceProps {
  color: string;
  size: number;
  left: string;
  shape: 'circle' | 'square' | 'triangle' | 'star' | 'semicircle';
}

const ConfettiPiece = ({
  color, size, left, shape,
}: ConfettiPieceProps) => {
  const getShapeStyle = () => {
    switch (shape) {
      case 'circle':
        return 'confetti-circle';
      case 'square':
        return 'confetti-square';
      case 'triangle':
        return 'confetti-triangle';
      case 'semicircle':
        return 'confetti-semicircle';
      default:
        return '';
    }
  };

  return (
    <motion.div
      className={`absolute top-0 ${getShapeStyle()} `}
      style={{
        width: shape === 'triangle' || shape === 'star' ? 0 : size,
        height: shape === 'triangle' || shape === 'star' ? 0 : size,
        backgroundColor: shape === 'triangle' || shape === 'star' ? 'transparent' : color,
        left,
      }}
      animate={{
        y: ['0vh', '100vh'],
        rotate: [0, 360],
      }}
      transition={{
        duration: Math.random() * 6 + 3,
        repeat: Infinity,
        ease: 'linear',
      }}
    />
  );
};

export default function Confetti() {
  return (
    <div className="absolute inset-0 overflow-hidden">
      {Array.from({ length: CONFETTI_COUNT }).map((_, i) => {
        return (
          <ConfettiPiece
            // eslint-disable-next-line react/no-array-index-key
            key={i}
            color={COLORS[Math.floor(Math.random() * COLORS.length)]}
            size={Math.random() * 10 + 5}
            left={`${Math.random() * 100}%`}
            shape={['circle', 'square', 'triangle', 'semicircle'][Math.floor(Math.random() * 4)] as 'circle' | 'square' | 'triangle' | 'semicircle'}
          />
        );
      })}
    </div>
  );
}
